import { SET_CURRENT_DOMAIN } from './Constants'

export const setCurrentDomain = domain => {
  return { type: SET_CURRENT_DOMAIN, domain }
}
